let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("9vzCL")).then(() => parcelRequire('1DAKk'));